<template lang="pug">
.filter-select
  .ui.item.small.menu(:class='$formatters.number_to_word(items.length)')
    .item(v-for='i in items', :class='{active: i === item}', @click='select(i)')
      | {{ i.label }}
</template>

<script>
export default {
  name: 'filter-select',
  props: {
    value: { type: String, default: null },
    filter: { type: null, required: true },
  },
  computed: {
    items() {
      if (!this.filter)
        return []
      if (Array.isArray(this.filter))
        return this.filter
      return this.filter.selects || []
    },
  },
  data() {
    return {
      inner_result: null,
      item: null,
    }
  },
  watch: {
    value() {
      this.init()
    },
  },
  mounted() {
    this.init(this.value || this.filter.default || null)
  },
  methods: {
    init(select) {
      if (select === undefined) select = this.value
      this.item = this.items.filter(i => i && i.name === select)[0]
      this.select(this.item)
    },
    $filter(data) {
      if (this.item && this.item.filter && typeof this.item.filter === 'function')
        return data.filter(this.item.filter)
      return data
    },
    select(item) {
      this.item = item
      if (item) {
        this.$emit('update:select', item.name)
        this.$emit('input', item.name)
        this.$emit('filter')
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// FilterSelect.vue?125e1f03